<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        payload.filter();
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        filter:function(){
            Request.do(this, 'GET', Request.getDefaultHeader(this), null, `${Endpoints.model.create}`,
        (response)=>{//SUCCESS CALLBACK
            this.items = response.results;
        },
        (error)=>{//ERROR CALLBACK
            console.log(error);
        });
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        camelize: Common.camelize
    }
}
</script>
